import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';
import { GiHamburgerMenu } from 'react-icons/gi';
import { CgProfile } from 'react-icons/cg';
import { useState, useEffect, useRef } from 'react';
import { BoldTextColor, PrimaryBackground, PrimaryTextColor, ShadowColor } from '../../../app/theme/tokens/colors';
import { usePortalStore } from '../../../stores/portalStore';
import { LoginService } from '../../../services/auth';
// import { Notifications } from '../../notifications/Notifications';

export const MainHeaderBase = styled.div`
  background: rgb(8, 77, 1);
  background: linear-gradient(90deg, rgba(8, 77, 1, 1) 0%, rgba(8, 77, 1, 1) 47%, rgba(49, 131, 0, 1) 100%);
  display: flex;
  height: 60px;
  position: relative;
  padding: 5px;
`;

const LogoTile = styled.div`
  width: 220px;
  height: auto;
  position: relative;
  background-image: url(/icones/logo.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
`;
const MenuButtonTile = styled.div`
  color: white;
  text-align: center;
  line-height: 60px;
  min-width: 60px;
  height: 60px;
  position: relative;
  cursor: pointer;
  font-size: 24px;
`;

const GlobalSearchTile = styled.div`
  width: 100%;
  height: 60px;
  position: relative;
`;

const SpacerTile = styled.div`
  width: 100%;
  height: 60px;
  position: relative;
`;

const ProfileTile = styled.div`
  color: white;
  text-align: center;
  height: 60px;
  position: relative;
  cursor: pointer;
  align-items: center;
  display: flex;
  margin-right: 20px;
`;

const ProfilePopupTile = styled.div`
  background-color: ${PrimaryBackground};
  min-width: 280px;
  position: absolute;
  cursor: auto;
  left: -240px;
  border-radius: 15px;
  box-shadow: 0px 0px 10px ${ShadowColor};
  display: block;
  padding: 20px;
  box-sizing: border-box;
  z-index: 2;
`;


export class SessionCountDown {
    static tooltipContainerStyle = { position: 'relative' }
    static tooltipStyle = {
        position: 'absolute', bottom: '120%', left: 0, backgroundColor: '#fff', color: '#333', padding: '6px 10px',
        borderRadius: 6, whiteSpace: 'nowrap', zIndex: 9999, border: '2px solid rgb(49, 131, 0)', width: '100%'
    }
    static _isDEBUG = false;
    static _isVisible = false;
    static show() {
        SessionCountDown._isVisible = true;
    }
    static hide() {
        SessionCountDown._isVisible = false;
    }
    static isVisible() {
        return SessionCountDown._isVisible && SessionCountDown._isDEBUG;
    }
    static getRemainingText() {
        const token = localStorage.getItem('idToken');
        if (!token) return 'Sessão não encontrada';
        try {
            const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
            if (!payload.exp) return 'Sessão inválida';
            const now = Math.floor(Date.now() / 1000);
            const remaining = payload.exp - now;
            if (remaining <= 0) return 'Sessão expirada';
            const h = Math.floor(remaining / 3600);
            const m = Math.floor((remaining % 3600) / 60);
            const s = remaining % 60;
            const pad = (n) => String(n).padStart(2, '0');
            return `Sessão expira em ${pad(h)}:${pad(m)}:${pad(s)}`;
        } catch {
            return 'Sessão inválida';
        }
    }

}

const MenuButton = () => {
    const setMenuOpenState = usePortalStore((state) => state.setMenuOpenState);
    const menuOpenState = usePortalStore((state) => state.ui.menuOpenState);
    return (
        <MenuButtonTile>
            <GiHamburgerMenu
                onClick={() => {
                    setMenuOpenState(!menuOpenState);
                }}
            ></GiHamburgerMenu>
        </MenuButtonTile>
    );
};

const ProfileButton = () => {
    const [showPopup, setShowPopup] = useState(false);
    //const currentUser = usePortalStore((state) => state.currentUser);
    const [currentUser, setCurrentUser] = useState(LoginService.currentUser());

    const [tooltip, setTooltip] = useState('');
    const tooltipInterval = useRef(null);

    const closeTimeout = () => {
        setTimeout(() => {
            setShowPopup(false);
        }, 5000);
    };
    const signout = async () => {
        try {
            await LoginService.signOut();
        } catch {
            console.log('erro fazendo logout')
        }
    };

    useEffect(() => {
        setCurrentUser(LoginService.currentUser());
    }, []);

    useEffect(() => {
        /** Inicio timer no tooltip */
        const update = () => setTooltip(SessionCountDown.getRemainingText());
        update();
        if (tooltipInterval.current == null) {
            tooltipInterval.current = window.setInterval(update, 1000);
        }
        return () => {
            if (tooltipInterval.current != null) {
                clearInterval(tooltipInterval.current);
                tooltipInterval.current = null;
            }
        };
        /** Fim timer no tooltip */
    }, []);

    return (
        <ProfileTile>
            <div
                style={{ display: 'flex', alignItems: 'center' }}
                onClick={() => {
                    setShowPopup(!showPopup);
                    if (!showPopup) {
                        closeTimeout();
                    }
                }}
            >
                <div style={{ fontSize: '16px', marginRight: '5px', marginTop: '' }}>Perfil</div>
                <div>
                    <CgProfile style={{ fontSize: '28px' }}></CgProfile>

                    {showPopup ? (
                        <ProfilePopupTile>
                            <div onMouseEnter={() => SessionCountDown.show()} onMouseLeave={() => SessionCountDown.hide()} title={tooltip}
                                style={{ ...SessionCountDown.tooltipContainerStyle, color: BoldTextColor, fontWeight: 'bold' }}>
                                {currentUser.companyName}
                                {SessionCountDown.isVisible() && (<div style={SessionCountDown.tooltipStyle}>{tooltip}</div>)}
                            </div>
                            <div
                                style={{
                                    color: PrimaryTextColor,
                                    fontWeight: '300',
                                    marginTop: '15px',
                                }}
                            >
                                Email:{currentUser.email}
                            </div>
                            <div
                                style={{
                                    color: PrimaryTextColor,
                                    fontWeight: '300',
                                    marginTop: '15px',
                                }}
                            >
                                CNPJ:{currentUser.cnpj}
                            </div>
                            <hr style={{ marginTop: '20px', marginBottom: '20px' }}></hr>

                            <div
                                style={{
                                    color: BoldTextColor,
                                    fontWeight: '600',
                                    marginTop: '15px',
                                    cursor: 'pointer',
                                }}
                                onClick={signout}
                            >
                                Sair
                            </div>
                        </ProfilePopupTile>
                    ) : (
                        <></>
                    )}
                </div>
            </div>
        </ProfileTile>
    );
};

export const MainHeader = () => {
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });

    return (
        <>
            <MainHeaderBase>
                {!isTabletOrMobile ? (
                    <>
                        <LogoTile></LogoTile>
                        <MenuButton></MenuButton>
                        <GlobalSearchTile></GlobalSearchTile>
                        {/* <Notifications></Notifications> */}
                        <ProfileButton></ProfileButton>
                    </>
                ) : (
                    <>
                        <LogoTile></LogoTile>
                        <MenuButton></MenuButton>
                        <SpacerTile></SpacerTile>
                        {/* <Notifications></Notifications> */}
                        <ProfileButton></ProfileButton>
                    </>
                )}
            </MainHeaderBase>
        </>
    );
};

export const ReadOnlyMainHeader = () => {
    return (
        <MainHeaderBase>
            <LogoTile></LogoTile>
        </MainHeaderBase>
    );
};
